module.exports = __webpack_public_path__ + "img/40.a132b592.png";